export const isValidJSON = (data: unknown): boolean => {
  if (typeof data !== 'string') {
    return false;
  }
  try {
    JSON.parse(data);
    return true;
  } catch {
    return false;
  }
};
